
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DeleteBoxEditable from "./DeleteBoxEditable.vue";

@Component({
  components: {
    DeleteBoxEditable,
  },
})
class ImageSelector extends Vue {
  @Prop({ default: null }) readonly imagePage!: string;
  @Prop({ default: false }) readonly isAudio!: string;
  @Prop({ default: false }) readonly isVideo!: boolean;
  @Prop({ default: false }) readonly is3D!: boolean;
  @Prop({ default: false }) readonly justPNG!: boolean;
  @Prop({ default: false }) readonly heightCheck!: boolean;
  imageArray: string[] = [];
  nameArray: string[] = [];
  elementArray: string[] = [];
  selectedItem = {
    imgURL: "",
    imgName: "",
    imgSize: "",
  };
  fileError = "";
  isLoading = false;

  get getImagePage(): string {
    return this.imagePage;
  }

  get getAcceptableFile(): string {
    if (this.isAudio) {
      return "audio/mp3";
    } else if (this.isVideo) {
      return "video/mp4, video/webm";
    } else if (this.is3D) {
      return ".obj";
    } else if (this.justPNG) {
      return "image/png";
    } else {
      return "image/jpeg, image/png";
    }
  }

  getSelectedCss(option: string): string {
    if (this.selectedItem.imgURL == option) {
      return "image-width-selected";
    }
    return "image-width";
  }

  created(): void {
    this.getAllImageLinks();
  }

  async getAllImageLinks(): Promise<void> {
    this.isLoading = true;
    await this.$store
      .dispatch("authenication/getAllImageSrcFromRemote", this.getImagePage)
      .then((result) => {
        result.items.forEach((element: any) => {
          this.$store
            .dispatch("authenication/getImageSrcFromRemote", element.fullPath)
            .then((imageLink) => {
              this.nameArray.push(element.name);
              this.elementArray.push(element.fullPath);
              this.imageArray.push(imageLink);
            });
        });
        this.isLoading = false;
      });
  }

  imageSelected(path: string, index: number): void {
    this.selectedItem.imgURL = path;
    this.selectedItem.imgName = this.nameArray[index];
    this.selectedItem.imgSize = this.getImageSize(path);
  }

  getImageSize(path: string): string {
    let img = new Image();
    img.src = path;
    return img.width + "x" + img.height;
  }

  handleCloseButtonPress(): void {
    this.$emit("handleCloseButtonPress");
  }

  selectImage(): void {
    this.$emit("returnImagePath", this.selectedItem.imgName);
  }

  async fileUpload(event: any): Promise<void> {
    this.fileError = "";
    if (this.heightCheck) {
      for (var i = 0; i < event.target.files.length; i++) {
        var file = event.target.files[i];
        const photoUrl = URL.createObjectURL(file);
        const image = new Image();
        await new Promise((resolve) => {
          image.onload = () => {
            const dimensions = {
              height: image.height,
              width: image.width,
            };
            resolve(dimensions);
          };
          image.src = photoUrl;
        });
        if (image.height < 1024 && image.width < 1024) {
          this.fileUploadFirebase(event);
        } else {
          this.isLoading = false;
          this.fileError = "File type to large";
          this.$bvModal.show("modal-sm");
        }
      }
    } else {
      this.fileUploadFirebase(event);
    }
  }

  fileUploadFirebase(event: any): void {
    for (var i = 0; i < event.target.files.length; i++) {
      this.isLoading = true;
      if (this.checkFileName(event.target.files[i])) {
        var data = {
          file: event.target.files[i],
          path: this.imagePage,
        };
        this.$store
          .dispatch("authenication/uploadFile", data)
          .then(async (element) => {
            if ((await element.message) === "Success") {
              this.$store
                .dispatch(
                  "authenication/getImageSrcFromRemote",
                  element.ref.fullPath
                )
                .then((imageLink) => {
                  this.nameArray.push(element.ref.name);
                  this.elementArray.push(imageLink.fullPath);
                  this.imageArray.push(imageLink);
                  this.isLoading = false;
                });
            } else {
              this.isLoading = false;
              this.fileError = element;
              this.$bvModal.show("modal-sm");
            }
          });
      } else {
        this.isLoading = false;
        this.fileError = "Not the correct file type";
        this.$bvModal.show("modal-sm");
      }
    }
  }
  checkFileName(file: any): boolean {
    if (this.isAudio) {
      if (file.name.match(/.(mp3)$/i)) {
        return true;
      }
    } else if (this.isVideo) {
      if (file.name.match(/.(mp4|webm)$/i)) {
        return true;
      }
    } else if (this.is3D) {
      if (file.name.match(/.(obj|fbx)$/i)) {
        return true;
      }
    } else {
      if (file.name.match(/.(jpg|jpeg|png)$/i)) {
        return true;
      }
    }
    return false;
  }
  openDeleteBox(): void {
    this.$bvModal.show("team-modal-delete-editable");
  }
  deleteItem(): void {
    this.$store
      .dispatch(
        "authenication/deleteFile",
        this.imagePage + "" + this.selectedItem.imgName
      )
      .then((results) => {
        if (results === "success") {
          this.$bvModal.hide("team-modal-delete");
          this.imageArray = [];
          this.nameArray = [];
          this.elementArray = [];
          this.selectedItem = {
            imgURL: "",
            imgName: "",
            imgSize: "",
          };
          this.getAllImageLinks();
        } else {
          this.fileError = results;
          this.$bvModal.show("modal-sm");
        }
      });
  }
  @Watch("imagePage")
  async onStringValueChanged(value: boolean): Promise<void> {
    this.imageArray = [];
    this.nameArray = [];
    this.elementArray = [];
    this.selectedItem = {
      imgURL: "",
      imgName: "",
      imgSize: "",
    };
    this.getAllImageLinks();
  }
}

export default ImageSelector;
